import React from 'react'

const LowerBarSearch = () => {
  return (
    <>
      <div id="mask" />
          <div className="adv-search" id="search">
            <form action="#">
              <select name="" id="resizing_select">
                <option value="">
                  All
                </option>
                <option value="">Mobiles</option>
                <option value="">Laptops</option>
                <option value="">TV</option>
                <option value="">Audio</option>
                <option value="">Appliances</option>
                <option value="">Cameras</option>
                <option value="">Desktop</option>
                <option value="">Headphone</option>
              </select>
              <select id="width_tmp_select">
                <option id="width_tmp_option" />
              </select>
              <input
                type="text"
                className="form-control"
                placeholder="Search Your Keywords"
              />
              <button type="submit" className="btn btn-search">
                Search
              </button>
            </form>
          </div>
    </>
  )
}

export default LowerBarSearch